// assets/icoro-oil-diagnosis-ga4.js
(function () {
  var GA4_MEASUREMENT_ID = "G-S4GQQHMMGT";
  var DIAGNOSIS_SECTION_SELECTOR = "#shopify-section-template--19523757834342__vertical-filters";
  var RESULTS_SELECTOR = "#OilDiagnosisResults-template--19523757834342__vertical-filters";
  var FORM_SELECTOR = "collections-filtering form.section-vertical-filters-form";
  var STORAGE_KEY = "icoroOilDiagnosisProductContext";
  var STORAGE_TTL_MS = 30 * 60 * 1000;

  var started = false;
  var searchSequence = 0;
  var pendingResultSequence = 0;
  var lastResultSentSequence = 0;
  var resultSendTimer = null;
  var buyNowSent = false;

  function ensureGtag() {
    window.dataLayer = window.dataLayer || [];

    if (typeof window.gtag !== "function") {
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
    }

    if (!document.querySelector('script[data-icoro-ga4-loader="true"]')) {
      var script = document.createElement("script");
      script.async = true;
      script.src =
        "https://www.googletagmanager.com/gtag/js?id=" +
        encodeURIComponent(GA4_MEASUREMENT_ID);
      script.setAttribute("data-icoro-ga4-loader", "true");
      document.head.appendChild(script);

      window.gtag("js", new Date());

      window.gtag("config", GA4_MEASUREMENT_ID, {
        send_page_view: false
      });
    }
  }

  function sendGa4Event(eventName, params) {
    ensureGtag();

    var eventParams = Object.assign(
      {
        transport_type: "beacon"
      },
      params || {}
    );

    window.gtag("event", eventName, eventParams);
  }

  function getActiveDiagnosisRoot(eventTarget) {
    if (!eventTarget || !eventTarget.closest) {
      return null;
    }

    return eventTarget.closest("collections-filtering");
  }

  function getActiveTabLabel() {
    var section = document.querySelector(DIAGNOSIS_SECTION_SELECTOR);

    if (!section) {
      return "";
    }

    var activeTab = section.querySelector(".tab-nav-item.is-active");

    if (!activeTab) {
      return "";
    }

    return (activeTab.textContent || "").trim();
  }

  function getSelectedValues(root) {
    if (!root) {
      return {
        diagnosis_location: "top",
        vehicle_type: getActiveTabLabel(),
        maker: "",
        car_model: "",
        engine_code: "",
        year: ""
      };
    }

    var maker = root.querySelector('select[data-label="car_manufacturer"]');
    var carModel = root.querySelector('select[data-label="car_model"]');
    var engineCode = root.querySelector('select[data-label="car_engine_model"]');
    var year = root.querySelector('select[data-label="car_model_year"]');

    return {
      diagnosis_location: "top",
      vehicle_type: getActiveTabLabel(),
      maker: maker ? maker.value || "" : "",
      car_model: carModel ? carModel.value || "" : "",
      engine_code: engineCode ? engineCode.value || "" : "",
      year: year ? year.value || "" : ""
    };
  }

  function sendStartOnce(root) {
    if (started) {
      return;
    }

    started = true;

    sendGa4Event("oil_diagnosis_start", getSelectedValues(root));
  }

  function getResultCount(resultsBody) {
    if (!resultsBody) {
      return 0;
    }

    var productLinks = resultsBody.querySelectorAll('a[href*="/products/"]');

    if (productLinks.length > 0) {
      var handles = {};

      productLinks.forEach(function (link) {
        var href = link.getAttribute("href") || "";
        var match = href.match(/\/products\/([^?/#]+)/);

        if (match && match[1]) {
          handles[match[1]] = true;
        }
      });

      return Object.keys(handles).length || productLinks.length;
    }

    var productCards = resultsBody.querySelectorAll(".card-product, .grid-item");

    return productCards.length;
  }

  function getFirstDiagnosisRoot() {
    return document.querySelector("collections-filtering");
  }

  function scheduleResultSend() {
    if (!pendingResultSequence) {
      return;
    }

    if (resultSendTimer) {
      window.clearTimeout(resultSendTimer);
    }

    resultSendTimer = window.setTimeout(function () {
      sendResultIfVisible(pendingResultSequence);
    }, 500);
  }

  function sendResultIfVisible(sequence) {
    var resultsElement = document.querySelector(RESULTS_SELECTOR);

    if (!sequence || sequence !== pendingResultSequence) {
      return;
    }

    if (sequence === lastResultSentSequence) {
      return;
    }

    if (!resultsElement || resultsElement.hasAttribute("hidden")) {
      scheduleResultSend();
      return;
    }

    var body = resultsElement.querySelector("[data-results-body]");

    if (!body) {
      scheduleResultSend();
      return;
    }

    var text = (body.textContent || "").trim();

    if (!text) {
      scheduleResultSend();
      return;
    }

    var values = getSelectedValues(getFirstDiagnosisRoot());
    var resultCount = getResultCount(body);

    values.result_count = resultCount;
    values.search_sequence = sequence;

    lastResultSentSequence = sequence;
    pendingResultSequence = 0;

    sendGa4Event("oil_diagnosis_result", values);
  }

  function saveDiagnosisProductContext(params) {
    try {
      window.sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(
          Object.assign(
            {
              saved_at: Date.now()
            },
            params || {}
          )
        )
      );
    } catch (error) {
      // sessionStorage が使えない環境では保存せず、クリックイベントのみ送信します。
    }
  }

  function getDiagnosisProductContext() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);

      if (!raw) {
        return null;
      }

      var parsed = JSON.parse(raw);

      if (!parsed || !parsed.saved_at) {
        window.sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }

      if (Date.now() - parsed.saved_at > STORAGE_TTL_MS) {
        window.sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return parsed;
    } catch (error) {
      return null;
    }
  }

  function getCurrentProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^?/#]+)/);

    if (match && match[1]) {
      return match[1];
    }

    return "";
  }

  function isBuyNowTarget(target) {
    if (!target || !target.closest) {
      return false;
    }

    var button = target.closest("button, a, shopify-buy-it-now-button, shopify-accelerated-checkout");

    if (!button) {
      return false;
    }

    var text = (button.textContent || "").replace(/\s+/g, "");

    if (text.indexOf("今すぐ購入") !== -1) {
      return true;
    }

    if (button.matches(".shopify-payment-button__button")) {
      return true;
    }

    if (button.matches("[data-testid*='Checkout-button']")) {
      return true;
    }

    if (button.matches("[data-shopify='payment-button']")) {
      return true;
    }

    if (button.closest(".shopify-payment-button")) {
      return true;
    }

    return false;
  }

  function isAddToCartTarget(target) {
    if (!target || !target.closest) {
      return false;
    }

    var button = target.closest("button, a, input[type='submit']");

    if (!button) {
      return false;
    }

    if (isBuyNowTarget(button)) {
      return false;
    }

    var text = (button.textContent || button.value || "").replace(/\s+/g, "");

    if (text.indexOf("カートに追加") !== -1) {
      return true;
    }

    if (button.getAttribute("name") === "add") {
      return true;
    }

    if (button.matches("[data-add-to-cart]")) {
      return true;
    }

    if (button.matches("[data-product-add-to-cart]")) {
      return true;
    }

    if (button.matches(".product-form-submit")) {
      return true;
    }

    if (button.matches(".product-actions-add-to-cart")) {
      return true;
    }

    if (button.closest(".product-actions-add-to-cart")) {
      return true;
    }

    var form = button.closest('form[action*="/cart/add"]');

    if (form && button.getAttribute("type") !== "button") {
      return true;
    }

    return false;
  }

  function buildDiagnosisProductPageParams(context) {
    var currentProductHandle = getCurrentProductHandle();

    if (
      context.product_handle &&
      currentProductHandle &&
      context.product_handle !== currentProductHandle
    ) {
      return null;
    }

    return {
      diagnosis_location: context.diagnosis_location || "top",
      vehicle_type: context.vehicle_type || "",
      product_handle: context.product_handle || currentProductHandle,
      product_url: context.product_url || window.location.pathname,
      current_product_handle: currentProductHandle
    };
  }

  function bindFormEvents() {
    document.addEventListener(
      "change",
      function (event) {
        if (!event.target || !event.target.matches("select.dropdown-filter")) {
          return;
        }

        sendStartOnce(getActiveDiagnosisRoot(event.target));
      },
      true
    );

    document.addEventListener(
      "submit",
      function (event) {
        if (!event.target || !event.target.matches(FORM_SELECTOR)) {
          return;
        }

        var root = getActiveDiagnosisRoot(event.target);

        sendStartOnce(root);

        searchSequence += 1;
        pendingResultSequence = searchSequence;

        var values = getSelectedValues(root);
        values.search_sequence = searchSequence;

        sendGa4Event("oil_diagnosis_search", values);

        scheduleResultSend();
      },
      true
    );
  }

  function bindResultObserver() {
    var resultsElement = document.querySelector(RESULTS_SELECTOR);

    if (!resultsElement) {
      return;
    }

    var observer = new MutationObserver(function () {
      scheduleResultSend();
    });

    observer.observe(resultsElement, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["hidden", "class"]
    });
  }

  function bindProductClickEvents() {
    document.addEventListener(
      "click",
      function (event) {
        var resultsElement = document.querySelector(RESULTS_SELECTOR);

        if (!resultsElement || resultsElement.hasAttribute("hidden")) {
          return;
        }

        var link = event.target.closest(RESULTS_SELECTOR + ' a[href*="/products/"]');

        if (!link) {
          return;
        }

        var href = link.getAttribute("href") || "";
        var productHandle = "";
        var match = href.match(/\/products\/([^?/#]+)/);

        if (match && match[1]) {
          productHandle = match[1];
        }

        var params = {
          diagnosis_location: "top",
          vehicle_type: getActiveTabLabel(),
          product_handle: productHandle,
          product_url: href
        };

        saveDiagnosisProductContext(params);

        sendGa4Event("oil_diagnosis_product_click", params);
      },
      true
    );
  }

  function bindBuyNowClickEvents() {
    document.addEventListener(
      "click",
      function (event) {
        if (buyNowSent) {
          return;
        }

        if (!isBuyNowTarget(event.target)) {
          return;
        }

        var context = getDiagnosisProductContext();

        if (!context) {
          return;
        }

        var params = buildDiagnosisProductPageParams(context);

        if (!params) {
          return;
        }

        buyNowSent = true;

        sendGa4Event("oil_diagnosis_buy_now_click", params);
      },
      true
    );
  }

  function bindAddToCartClickEvents() {
    document.addEventListener(
      "click",
      function (event) {
        if (!isAddToCartTarget(event.target)) {
          return;
        }

        var context = getDiagnosisProductContext();

        if (!context) {
          return;
        }

        var params = buildDiagnosisProductPageParams(context);

        if (!params) {
          return;
        }

        sendGa4Event("oil_diagnosis_add_to_cart_click", params);
      },
      true
    );
  }

  function initDiagnosisPageTracking() {
    var diagnosisSection = document.querySelector(DIAGNOSIS_SECTION_SELECTOR);

    if (!diagnosisSection) {
      return;
    }

    bindFormEvents();
    bindResultObserver();
    bindProductClickEvents();
  }

  function init() {
    initDiagnosisPageTracking();
    bindAddToCartClickEvents();
    bindBuyNowClickEvents();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
